/**
 * The Plan-editor SECTIONS (PLAN.md M7 screen 1 — "Form-based, left-nav sections, ProjectionLab-
 * style"). Each maps to a section component editing one slice of the `Plan`. The editor renders an
 * intra-page section nav from this list and the active section's component.
 */
export type EditorSectionId =
  | 'household'
  | 'accounts'
  | 'income'
  | 'expenses'
  | 'events'
  | 'strategy';

export const EDITOR_SECTIONS: ReadonlyArray<{ id: EditorSectionId; label: string; blurb: string }> =
  [
    { id: 'household', label: 'Household', blurb: 'People & birth years' },
    { id: 'accounts', label: 'Accounts', blurb: 'Balances, kinds & allocation' },
    { id: 'income', label: 'Income', blurb: 'Salary & other inflows' },
    { id: 'expenses', label: 'Expenses', blurb: 'Spending by category' },
    { id: 'events', label: 'Life events', blurb: 'Retirement, house, education' },
    { id: 'strategy', label: 'Strategy', blurb: 'Allocation & order, horizon' },
  ];
